import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SolicitudesComponent } from './solicitudes.component';
import { Routes, RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DataTablesModule } from 'angular-datatables';
import { SolicitudDetallesComponent } from './solicitud-detalle/solicitud-detalles.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RechazoComponent } from './rechazo/rechazo.component';
import { CapacidadPagoMModule } from '../capacidad-pago-m/capacidad-pago-m.module';
import { CapacidadPagoModule } from '../capacidad-pago/capacidad-pago.module';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { RespuestaCreditoComponent } from './respuesta-credito/respuesta-credito.component';
import {MatTableModule} from '@angular/material/table';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import { LoginGuard } from 'src/app/guards/login.guard';
import { RolesGuard } from 'src/app/guards/roles.guard';
import { IMaskModule } from 'angular-imask';

const routes: Routes = [
  { path: 'solicitudes/:mode/:profile', pathMatch: 'full', component: SolicitudesComponent, canActivate: [LoginGuard, RolesGuard], data: {roles: ['Asesor integral', 'Auxiliar de Operaciones / Seguros', 'Auxiliar de Operaciones / Proceso', 'Auxiliar de crédito y entregas', 'Analista de crédito']} },
  { path: 'respuesta-credito', component: RespuestaCreditoComponent, canActivate: [RolesGuard], data: {roles: ['Analista de crédito'] }},
  { path: 'solicitudes/detalles/:id', component: SolicitudDetallesComponent }
];

@NgModule({
  declarations: [
    SolicitudesComponent,
    SolicitudDetallesComponent,
    RechazoComponent,
    RespuestaCreditoComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    RouterModule,
    NgxSpinnerModule,
    DataTablesModule,
    NgSelectModule,
    FormsModule,
    NgbDatepickerModule,
    CapacidadPagoMModule,
    CapacidadPagoModule,
    ReactiveFormsModule,
    MatTableModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatInputModule,
    MatButtonModule,
    IMaskModule
  ]
})
export class SolicitudesModule { }
